import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { keyframes } from 'tss-react'

const useStyles = makeStyles()(theme => ({
  divider: {
    height: 1,
    background: 'rgba(255, 255, 255, 0.1)',
    margin: theme.spacing(2, 4),
    animation: `${keyframes`
      from: { opacity: 0 }
      to: { opacity: 1 }
    `} 0.4s ease-out backwards`,
    animationDelay: '250ms',
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1, 4),
    },
  },
}))

const PageHeaderDivider = (props: any) => {
  const { children, styleName, ...restProps } = props
  const { classes } = useStyles()

  return (
    <div className={styleName ? `${classes.divider} ${styleName}` : classes.divider} {...restProps} />
  )
}

export default React.memo(PageHeaderDivider)
